module.exports = __webpack_public_path__ + "static/IWGHQI0-bb135a1736e4724cd91ee2c26e4c8bc3.jpg";